import { memo } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import type { Setup } from "features/setups/types";
import { useResourceContext } from "ui/widgets/Resource";
import type { ActionProps } from "./types";

const Edit = ({ row }: ActionProps) => {
    const { onOpen } = useResourceContext<Setup<string>>();

    const edit = () => onOpen(row);

    return (
        <ListItem disablePadding>
            <ListItemButton
                onPointerDown={edit}
            >
                <ListItemText primary='Edit' />
            </ListItemButton>
        </ListItem>
    );
};

export default memo(Edit);
